const requestQuote = {
  hero: {
    title: "Book a Free Consultation",
    description:
      "Fill out the form and our team will contact you as soon as possible to confirm the details.",
  },
  form: {
    title: "Inquiry form",
  },
  call: {
    prefix: "Prefer to call us?",
  },
};

export default requestQuote;

